import React, { forwardRef } from 'lib/react';
import PropTypes from 'prop-types';
import { EVTooltip, makeStyles } from '@eagleview/ev-comp-library';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  defaultTooltipClass: {
    background: theme.evPalette.charcoal[800],
    fontSize: '14px',
    borderRadius: '4px',
    alignItems: 'center',
    padding: '15px',
  },
  defaultArrowClass: {
    color: theme.evPalette.charcoal[800],
  },
}));

const Tooltip = forwardRef((props, ref) => {
  const {
    className, classes: { tooltip, arrow, ...classes }, children, ...rest
  } = props;
  const styles = useStyles();

  return (
    <EVTooltip
      className={className}
      classes={{
        arrow: clsx(styles.defaultArrowClass, arrow),
        tooltip: clsx(styles.defaultTooltipClass, tooltip),
        ...classes,
      }}
      ref={ref}
      {...rest}
    >
      {children}
    </EVTooltip>
  );
});

Tooltip.defaultProps = {
  className: '',
  classes: {},
};

Tooltip.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    tooltip: PropTypes.string,
    arrow: PropTypes.string,
  }),
};
export default Tooltip;
